var _class, _MobileMenu;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import defined from "terriajs-cesium/Source/Core/defined";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MobileMenuItem from "./MobileMenuItem";
import SettingPanel from "../Map/Panels/SettingPanel";
import SharePanel from "../Map/Panels/SharePanel/SharePanel";
import { withTranslation } from "react-i18next";
import Styles from "./mobile-menu.scss";
import { runInAction } from "mobx";
import LangPanel from "../Map/Panels/LangPanel/LangPanel";
import { applyTranslationIfExists } from "../../Language/languageHelpers";
import { Category, HelpAction } from "../../Core/AnalyticEvents/analyticEvents";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let MobileMenu = observer(_class = (_MobileMenu = class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  toggleMenu() {
    runInAction(() => {
      this.props.viewState.mobileMenuVisible = !this.props.viewState.mobileMenuVisible;
    });
  }
  onFeedbackFormClick() {
    runInAction(() => {
      this.props.viewState.feedbackFormIsVisible = true;
      this.props.viewState.mobileMenuVisible = false;
    });
  }
  hideMenu() {
    runInAction(() => {
      this.props.viewState.mobileMenuVisible = false;
    });
  }
  runStories() {
    this.props.viewState.runStories();
  }
  dismissSatelliteGuidanceAction() {
    this.props.viewState.toggleFeaturePrompt("mapGuidesLocation", true, true);
  }

  /**
   * If the help configuration defines an item named `mapuserguide`, this
   * method returns props for showing it in the mobile menu.
   */
  mapUserGuide() {
    const helpItems = this.props.terria.configParameters.helpContent;
    const mapUserGuideItem = helpItems === null || helpItems === void 0 ? void 0 : helpItems.find(_ref => {
      let {
        itemName
      } = _ref;
      return itemName === "mapuserguide";
    });
    if (!mapUserGuideItem) {
      return undefined;
    }
    const title = applyTranslationIfExists(mapUserGuideItem.title, this.props.i18n);
    return {
      href: mapUserGuideItem.url,
      caption: title,
      onClick: () => {
        var _this$props$terria$an;
        (_this$props$terria$an = this.props.terria.analytics) === null || _this$props$terria$an === void 0 || _this$props$terria$an.logEvent(Category.help, HelpAction.itemSelected, title);
      }
    };
  }
  render() {
    var _this$props$terria$co;
    const {
      t
    } = this.props;
    const hasStories = this.props.terria.configParameters.storyEnabled && defined(this.props.terria.stories) && this.props.terria.stories.length > 0;
    const mapUserGuide = this.mapUserGuide();

    // return this.props.viewState.mobileMenuVisible ? (
    return /*#__PURE__*/_jsxs("div", {
      children: [this.props.viewState.mobileMenuVisible && /*#__PURE__*/_jsx("div", {
        className: Styles.overlay,
        onClick: () => this.toggleMenu()
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(Styles.mobileNav, {
          [Styles.mobileNavHidden]: !this.props.viewState.mobileMenuVisible
        }),
        children: [this.props.menuLeftItems.map(menuItem => /*#__PURE__*/_jsx("div", {
          onClick: () => this.hideMenu(),
          children: menuItem
        }, menuItem ? menuItem.key : undefined)), /*#__PURE__*/_jsx("div", {
          onClick: () => this.hideMenu(),
          children: /*#__PURE__*/_jsx(SettingPanel, {})
        }), /*#__PURE__*/_jsx("div", {
          onClick: () => this.hideMenu(),
          children: /*#__PURE__*/_jsx(SharePanel, {
            terria: this.props.terria,
            viewState: this.props.viewState
          })
        }), this.props.menuItems.map(menuItem => /*#__PURE__*/_jsx("div", {
          onClick: () => this.hideMenu(),
          children: menuItem
        }, menuItem ? menuItem.key : undefined)), mapUserGuide && /*#__PURE__*/_jsx(MobileMenuItem, _objectSpread({}, mapUserGuide)), this.props.showFeedback && /*#__PURE__*/_jsx(MobileMenuItem, {
          onClick: () => this.onFeedbackFormClick(),
          caption: t("feedback.feedbackBtnText")
        }), hasStories && /*#__PURE__*/_jsx(MobileMenuItem, {
          onClick: () => this.runStories(),
          caption: t("story.mobileViewStory", {
            storiesLength: this.props.terria.stories.length
          })
        }), ((_this$props$terria$co = this.props.terria.configParameters.languageConfiguration) === null || _this$props$terria$co === void 0 ? void 0 : _this$props$terria$co.enabled) && /*#__PURE__*/_jsx("div", {
          onClick: () => this.hideMenu(),
          children: /*#__PURE__*/_jsx(LangPanel, {
            terria: this.props.terria,
            smallScreen: this.props.viewState.useSmallScreenInterface
          })
        })]
      })]
    });
  }
}, _defineProperty(_MobileMenu, "propTypes", {
  menuItems: PropTypes.arrayOf(PropTypes.element),
  menuLeftItems: PropTypes.arrayOf(PropTypes.element),
  viewState: PropTypes.object.isRequired,
  showFeedback: PropTypes.bool,
  terria: PropTypes.object.isRequired,
  i18n: PropTypes.object,
  allBaseMaps: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
}), _defineProperty(_MobileMenu, "defaultProps", {
  menuItems: [],
  showFeedback: false
}), _MobileMenu)) || _class;
export default withTranslation()(MobileMenu);